"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderContactRow = void 0;
var React = require("react");
exports.renderContactRow = function (row, j) {
    var value = (React.createElement("span", { dangerouslySetInnerHTML: { __html: row.value } }));
    if (row.value.startsWith('http')) {
        value = (React.createElement("a", { className: "o-link", target: "_blank", href: row.value }, row.value));
    }
    if (row.value.indexOf('@') >= 0) {
        value = (React.createElement("a", { className: "o-link", target: "_blank", href: "mailto:" + row.value }, row.value));
    }
    if (row.value.startsWith('+')) {
        value = (React.createElement("a", { className: "o-link", href: "tel:" + row.value }, row.value));
    }
    return (React.createElement("p", { key: j },
        React.createElement("span", { className: "c-guides__key" },
            row.label,
            ":"),
        " ",
        value));
};
